import { TableCell, TableRow } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/icons/deleteIcon.svg";
import HtmlTooltip from "components/Elements/HtmlTooltip";
import { isoDateWithoutTimeZone } from "helpers/utils";
import React from "react";

const ClientNoteRow = ({ row, classes, onViewNote, onDeleteNote }) => {
	return (
		<TableRow>
			<TableCell style={{ width: "170px" }}>{row.name}</TableCell>
			<TableCell style={{ width: "100px" }}>{isoDateWithoutTimeZone(row.date + "Z")}</TableCell>
			<TableCell className="note-field" style={{ whiteSpace: "unset" }}>
				<HtmlTooltip
					title={<div dangerouslySetInnerHTML={{ __html: row.note || "" }} />}
				>
					<div
						className="max-two-line"
						dangerouslySetInnerHTML={{ __html: row.note || "" }}
					/>
				</HtmlTooltip>
			</TableCell>
			<TableCell>
				<p className="new-link" onClick={() => onViewNote(row.note)}>
					View
				</p>
			</TableCell>
			<TableCell style={{ width: "50px" }}>
				<DeleteIcon className={classes.deleteIcon} onClick={onDeleteNote} />
			</TableCell>
		</TableRow>
	);
};

export default ClientNoteRow;
